import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelDynamic as _vModelDynamic, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c390025"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("FECHAR")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Termos de Uso ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("FECHAR")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("FECHAR")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Politica de Privacidade ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("FECHAR")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Insira seu número de celular ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Para continuar, digite o código que foi enviado via SMS/WHATSAPP para o número do seu celular ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Dados Principais ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Nome Completo")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Selecione seu Gênero")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Masculino ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Feminino ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Prefiro não dizer ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Email")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Infelizmente não podemos permitir o cadastro de menores de 18 anos. Confira se sua data de nascimento está correta. ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Data Nascimento")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Crie uma senha para acessar ")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Jaú Serve Delivery ")
const _hoisted_26 = ["type"]
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Confirme sua Senha: ")
const _hoisted_28 = ["type"]
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" As senhas digitadas não são iguais ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Sua senha precisa: ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Conter ao menos um número ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Conter ao menos uma letra maiúscula ")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " PolÍtica de Privacidade", -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode()
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" e os ")
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Termos de Uso", -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Aceito a Política de Privacidade ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Aceito os Termos de Uso ")
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Ler a Política de Privacidade ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Ler os Termos de Uso ")
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/img/logo.png",
    alt: "Jau Serve"
  })
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" AGORA FALTA POUCO ")
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Conclua seu cadastro para ter acesso a todas as vantagens de nosso aplicativo! ")
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_VueCountdown = _resolveComponent("VueCountdown")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_SelectDia = _resolveComponent("SelectDia")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_modal, {
        ref: "modal",
        "is-open": _ctx.isOpenTermos,
        "swipe-to-close": false,
        onDidDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenTermos=false)),
        "initial-breakpoint": 1,
        breakpoints: [1, 1]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { "force-overscroll": "true" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center b1",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpenTermos=false)),
                        shape: "round",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center b1",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    innerHTML: _ctx.termos,
                    size: "12"
                  }, null, 8, ["innerHTML"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center b1",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenTermos=false)),
                        shape: "round",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        "is-open": _ctx.isOpenPolitica,
        "swipe-to-close": false,
        onDidDismiss: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isOpenPolitica=false)),
        "initial-breakpoint": 1,
        breakpoints: [1, 1]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { "force-overscroll": "true" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center b1",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpenPolitica=false)),
                        size: "large",
                        shape: "round",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center b1",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    innerHTML: _ctx.politica,
                    size: "12"
                  }, null, 8, ["innerHTML"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center b1",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isOpenPolitica=false)),
                        size: "large",
                        shape: "round",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toStart())),
            color: "dark",
            size: "large",
            fill: "clear"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { icon: _ctx.chevronBack }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_swiper, {
            allowTouchMove: false,
            zoom: false,
            onSwiper: _ctx.onSwiper,
            onReachBeginning: _ctx.onFirst,
            onReachEnd: _ctx.onLast
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "tel",
                            class: "input-cadastro",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.cadastro.celular) = $event)),
                            onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (_ctx.toEnd()), ["prevent"]), ["tab"])),
                            onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.toEnd()), ["enter"])),
                            onMaska: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cadastro.celular_v = $event.target.dataset.maskRawValue))
                          }, null, 544), [
                            [_vModelText, _ctx.cadastro.celular],
                            [_directive_maska, ['(##)# ####-####', '(##)# ####-####']]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat font-12",
                        size: "12"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_otp_input, {
                            onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(($event: any) => (_ctx.handleOnComplete()), ["prevent"]), ["tab"])),
                            ref: "otpInput",
                            "input-classes": 'input-cadastro',
                            separator: "       ",
                            "num-inputs": 4,
                            "should-auto-focus": false,
                            "is-input-num": true,
                            onOnComplete: _ctx.handleOnComplete,
                            placeholder: ['*', '*', '*', '*']
                          }, null, 8, ["onOnComplete"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat font-12",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.erro_pin) + " ", 1),
                          _hoisted_11,
                          _hoisted_12,
                          _createVNode(_component_ion_button, {
                            class: "btn btn-primary",
                            color: "light",
                            size: "small",
                            shape: "round",
                            disabled: _ctx.pin.enviado,
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.toStart()))
                          }, {
                            default: _withCtx(() => [
                              (_ctx.pin.enviado)
                                ? (_openBlock(), _createBlock(_component_VueCountdown, {
                                    key: 0,
                                    time: 60000,
                                    onEnd: _cache[12] || (_cache[12] = ($event: any) => (_ctx.pin.enviado=false))
                                  }, {
                                    default: _withCtx(({ totalSeconds }) => [
                                      _createTextVNode("Solicitar novamente em " + _toDisplayString(totalSeconds) + " segundos ", 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createElementBlock("span", _hoisted_13, " Solicitar Novo Código"))
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            placeholder: "Nome Completo(documento)*",
                            type: "text",
                            class: "input-cadastro",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.cadastro.nome) = $event)),
                            onKeydown: _cache[15] || (_cache[15] = _withKeys(_withModifiers(($event: any) => (_ctx.toEnd()), ["prevent"]), ["tab"])),
                            onMaska: _cache[16] || (_cache[16] = ($event: any) => (_ctx.cadastro.nome = $event.target.dataset.maskRawValue))
                          }, null, 544), [
                            [_vModelText, _ctx.cadastro.nome]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_16
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat no-padding",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_radio_group, {
                            modelValue: _ctx.cadastro.sexo,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.cadastro.sexo) = $event)),
                            class: "no-padding"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    size: "12",
                                    id: "product_size",
                                    class: "no-padding"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item, { lines: "none" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, { class: "ion-no-margin" }, {
                                            default: _withCtx(() => [
                                              _hoisted_17
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_radio, {
                                            slot: "start",
                                            value: 0
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_item, { lines: "none" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, { class: "ion-no-margin" }, {
                                            default: _withCtx(() => [
                                              _hoisted_18
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_radio, {
                                            slot: "start",
                                            value: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_item, { lines: "none" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, { class: "ion-no-margin" }, {
                                            default: _withCtx(() => [
                                              _hoisted_19
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_radio, {
                                            slot: "start",
                                            value: 2
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createElementVNode("input", {
                            placeholder: "Email",
                            type: "email",
                            class: "input-cadastro",
                            onKeydown: _cache[18] || (_cache[18] = _withKeys(_withModifiers(($event: any) => (_ctx.toEnd()), ["prevent"]), ["tab"])),
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.cadastro.email) = $event))
                          }, null, 544), [
                            [_vModelText, _ctx.cadastro.email]
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.menor())
                        ? (_openBlock(), _createBlock(_component_ion_col, {
                            key: 0,
                            class: "font-montserrat font-15 red",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_SelectDia, {
                            "onUpdate:modelValue": _ctx.cadastro,
                            data: _ctx.cadastro
                          }, null, 8, ["onUpdate:modelValue", "data"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23,
                          _hoisted_24,
                          _hoisted_25
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "10"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            onKeydown: _cache[20] || (_cache[20] = _withKeys(_withModifiers(($event: any) => (_ctx.toEnd()), ["prevent"]), ["tab"])),
                            type: _ctx.passwordType?'password':'text',
                            class: "input-cadastro",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.cadastro.password) = $event))
                          }, null, 40, _hoisted_26), [
                            [_vModelDynamic, _ctx.cadastro.password]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.passwordType?_ctx.eyeOff:_ctx.eye,
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.passwordType=!_ctx.passwordType))
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-15",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_27
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "10"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            onKeydown: _cache[23] || (_cache[23] = _withKeys(_withModifiers(($event: any) => (_ctx.toEnd()), ["prevent"]), ["tab"])),
                            type: _ctx.passwordTypeConf?'password':'text',
                            class: "input-cadastro",
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.cadastro.password_conf) = $event))
                          }, null, 40, _hoisted_28), [
                            [_vModelDynamic, _ctx.cadastro.password_conf]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.passwordTypeConf?_ctx.eyeOff:_ctx.eye,
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.passwordTypeConf=!_ctx.passwordTypeConf))
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      (_ctx.v$.cadastro.password_conf.sameAsPassword.$invalid)
                        ? (_openBlock(), _createBlock(_component_ion_col, {
                            key: 0,
                            class: "font-montserrat font-11",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"]),
                              _hoisted_29
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-12",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-11",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.v$.cadastro.password.minLength.$invalid ? _ctx.close :_ctx.checkmark
                          }, null, 8, ["icon"]),
                          _createTextVNode(" Ter pelo menos " + _toDisplayString(_ctx.v$.cadastro.password.minLength.$params.min) + " caracteres ", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-11",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.v$.cadastro.password.hasnumber.$invalid ? _ctx.close :_ctx.checkmark
                          }, null, 8, ["icon"]),
                          _hoisted_31
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-11",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.v$.cadastro.password.hasupper.$invalid ? _ctx.close :_ctx.checkmark
                          }, null, 8, ["icon"]),
                          _hoisted_32
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_33,
                          _hoisted_34,
                          _hoisted_35,
                          _hoisted_36,
                          _hoisted_37,
                          _hoisted_38
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-montserrat font-10",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_radio_group, {
                            modelValue: _ctx.cadastro.privacidade,
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.cadastro.privacidade) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    size: "12",
                                    id: "product_size"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item, { lines: "none" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, { class: "ion-no-margin" }, {
                                            default: _withCtx(() => [
                                              _hoisted_39,
                                              _createVNode(_component_ion_icon, {
                                                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showPolitica())),
                                                icon: _ctx.helpCircle
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_radio, {
                                            slot: "start",
                                            value: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ion_radio_group, {
                            modelValue: _ctx.cadastro.termosdeuso,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.cadastro.termosdeuso) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    size: "12",
                                    id: "product_size"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item, { lines: "none" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, { class: "ion-no-margin" }, {
                                            default: _withCtx(() => [
                                              _hoisted_40,
                                              _createVNode(_component_ion_icon, {
                                                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showTermos())),
                                                icon: _ctx.helpCircle
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_radio, {
                                            slot: "start",
                                            value: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-12",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_41,
                          _hoisted_42
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-12",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            id: "open-termos",
                            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showPolitica())),
                            color: "light",
                            fill: "none",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.helpCircle }, null, 8, ["icon"]),
                              _hoisted_43
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-12",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            id: "open-politica",
                            onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showTermos())),
                            color: "light",
                            fill: "none",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.helpCircle }, null, 8, ["icon"]),
                              _hoisted_44
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_45
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_46,
                          _hoisted_47
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-montserrat font-12",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_48,
                          _hoisted_49
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSwiper", "onReachBeginning", "onReachEnd"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { class: "ion-no-border" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                class: "ion-text-center font-montserrat",
                size: "8"
              }),
              (!_ctx.isLast)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 0,
                    class: "ion-text-center",
                    size: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.toEnd())),
                        color: "light",
                        size: "large",
                        shape: "round",
                        expand: "block"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.chevronForward }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isLast)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 1,
                    class: "ion-text-center",
                    size: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.callSignUP())),
                        color: "danger",
                        size: "large",
                        shape: "jau",
                        expand: "block"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.isSend)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                                _createVNode(_component_ion_spinner, { name: "circular" })
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_51, "ENVIAR"))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}